import { useRoute, useRouteData } from "@bcm-dev/bcms-vite";
import { UIButton } from "components/ui";
import { SVGAsset } from "res";
import "./styles.css";

export default function AdvancedAlertsContent(props) {
    let { verified = false } = useRouteData().route ?? {};
    const navigate = useRoute();
    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };
    verified = data.verified ? data.verified : verified;

    const onManageAlerts = evt => navigate("/advancedAlerts/manageAlerts");
    const onManageRecipients = evt => navigate("/advancedAlerts/manageRecipients");

    return (
        <div className="advanced-alerts-content">
            <p className="page-subtitle">Manage Alerts and Recipients</p>

            { verified && 
            <div className="confirmation-banner flex-container flex-horizontal">
                <SVGAsset id="CircleCheckmarkIcon" className="set-width icon checkmark-icon" />
                <div className="flex-width confirm-text">The recipient was successfully verified.</div>
            </div>
            }

            <div className="flex-container flex-horizontal button-container vertical-stack">
                <div className="flex-container flex-vertical set-width">
                    <UIButton className="primary-button" text="Manage Alerts" dataPoint="advanced_alerts_manage_alerts_button" onClick={ onManageAlerts } />
                    <UIButton className="primary-button" text="Manage Recipients" dataPoint="advanced_alerts_manage_recipients_button" onClick={ onManageRecipients } />
                </div>
                <div className="flex-width" />
            </div>
        </div>
    );
}

export const getDefaultPageData = () => ({
 
});

export const getDefaultPageUI = () => ({
  
});